import { ShopperAiSettingsOptimizationType } from "@redotech/redo-model/shopper-ai-settings-optimization";
import { SettingsOptimizationDefinition } from "../optimization-types";
import { bundlesOptimization } from "./bundles-optimization";
import { discountsOptimization } from "./discounts-optimization";
import { orderEditingSkillsOptimization } from "./order-editing-skills-optimization";
import { proactivePromptsOptimization } from "./proactive-prompts-optimization";

export const settingsOptimizationDefinitions: Record<
  ShopperAiSettingsOptimizationType,
  SettingsOptimizationDefinition
> = {
  [ShopperAiSettingsOptimizationType.PROACTIVE_PROMPTS_OPTIMIZATION]:
    proactivePromptsOptimization,
  [ShopperAiSettingsOptimizationType.BUNDLES_OPTIMIZATION]: bundlesOptimization,
  [ShopperAiSettingsOptimizationType.DISCOUNTS_OPTIMIZATION]:
    discountsOptimization,
  [ShopperAiSettingsOptimizationType.ORDER_EDITING_SKILLS_OPTIMIZATION]:
    orderEditingSkillsOptimization,
};
